import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { graphql } from "gatsby";
import { PrismicRichText } from "@prismicio/react";

const Holder = styled.div`
  color: black;
`;

const ArticleGrid = styled.div`

  @media (${(props) => props.theme.breakpoints.md}) {
    display: grid;
    grid-template-columns: 2fr 3fr;
  }
`;

const Quote = styled.div`
  grid-column: 2 / 3;
  margin: 2rem 0;
  font-family: "Roboto Serif", serif;
  font-weight: bold;
  font-style: italic;
  ${(props) => props.theme.fluidType(8)}
  color: #404040;

  @media (${(props) => props.theme.breakpoints.md}) {
    padding-left: 0.5rem;
    width: 84%;
    ${(props) => props.theme.fluidType(2)}
  }  
`;

const SliceQuotePerspective = ({ slice }) => {
  const quote = slice.primary.quote.richText;

  return (
    <Holder>
        <ArticleGrid>
          <Quote>
            <PrismicRichText field={quote} />
          </Quote>
        </ArticleGrid>
    </Holder>
  );
};

SliceQuotePerspective.propTypes = {
  slice: PropTypes.object.isRequired,
};

export default SliceQuotePerspective;

export const query = graphql`
  fragment SliceQuotePerspective on PrismicPerspectiveDataBodyQuote {
    id
    slice_type
    primary {
      quote {
        richText
      }
    }
  }
`;